import { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { getApiBase } from '@services/api/apiConfig';
import { buildViewerUrl } from '@/utils/helpers/viewerUrl';

export function EmbedRedirectPage() {
  const { shareId = '' } = useParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;

    async function loadShare() {
      try {
        const res = await fetch(`${getApiBase()}/api/public/embed/${encodeURIComponent(shareId)}`, {
          credentials: 'omit',
        });
        const body = await res.json().catch(() => null);
        if (!res.ok) throw new Error(body?.error || `HTTP ${res.status}`);
        if (!active) return;
        window.location.replace(buildViewerUrl(body));
      } catch (err) {
        if (active) setError((err as Error)?.message || 'Unable to open embed');
      }
    }

    if (shareId) {
      void loadShare();
    } else {
      setError('Missing embed share ID');
    }

    return () => { active = false; };
  }, [shareId]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 3 }}>
      {error ? (
        <Alert severity="error" sx={{ maxWidth: 560 }}>{error}</Alert>
      ) : (
        <Box sx={{ display: 'grid', justifyItems: 'center', gap: 2 }}>
          <CircularProgress size={32} />
          <Typography sx={{ color: 'text.secondary' }}>Opening embed...</Typography>
        </Box>
      )}
    </Box>
  );
}
